<template>
  <div>
    <PageTitle icon="fa fa-home" main="BID / Tarefas Padrão" />
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col sm="12" md="6" lg="6">
              <b-form-group>
                <label for="">Tipo</label>
                <b-form-select @change="getData" v-model="search_type">
                  <b-form-select-option value="0"
                    >Todos os Tipos</b-form-select-option
                  >
                  <b-form-select-option value="1">OBRAS</b-form-select-option>
                  <b-form-select-option value="2"
                    >SERVIÇOS NÃO CONSULTORIA</b-form-select-option
                  >
                  <b-form-select-option value="3"
                    >CONSULTORIA FIRMAS</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="6">
              <b-form-group>
                <label for="">Tipo</label>
                <b-form-select @change="getData" v-model="search_type_revision">
                  <b-form-select-option value="0"
                    >Todos os Tipos de Revisão</b-form-select-option
                  >
                  <b-form-select-option value="1">EX-ANTE</b-form-select-option>
                  <b-form-select-option value="2">EX-POST</b-form-select-option>
                  <b-form-select-option value="3"
                    >NACIONAL</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8">
              <b-input-group class="mt-1 mb-2">
                <b-form-input
                  size="sm"
                  v-model="search"
                  type="text"
                ></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" @click="getData" variant="info">
                    <i class="fas fa-search"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-button
                size="sm"
                @click="newRecord()"
                class="mt-1"
                style="float: right"
                variant="success"
              >
                <i class="fas fa-plus"></i> Nova
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div style="overflow-y: auto; max-height: 400px">
                <b-table
                  id="tbl"
                  hover
                  bordered
                  resposive
                  small
                  striped
                  head-variant="dark"
                  selectable
                  select-mode="single"
                  selected-variant="primary"
                  show-empty
                  empty-text="Sem dados para exibir"
                  empty-filtered-text="Sem dados para exibir"
                  tbody-class="font08"
                  thead-class="font08"
                  tfoot-class="font08"
                  :per-page="pagination.perPage"
                  :current-page="pagination.currentPage"
                  :filter="search"
                  :items="types"
                  :fields="fields"
                  :busy="isBusy"
                >
                  <template v-slot:table-busy>
                    <div class="text-center my-2">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Carregando...</strong>
                    </div>
                  </template>
                  <template v-slot:cell(ind_ativo)="data">
                    <div class="text-center" v-if="data.item.ind_ativo === 0">
                      <b-badge variant="danger">Não</b-badge>
                    </div>
                    <div class="text-center" v-else>
                      <b-badge variant="secondary">Sim</b-badge>
                    </div>
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-button
                      size="sm"
                      variant="success"
                      @click="editRecord(data.item)"
                    >
                      <i class="fas fa-edit"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      variant="danger"
                      @click="deleteRecord(data.item)"
                    >
                      <i class="fas fa-trash"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click="viewRecord(data.item)"
                    >
                      <i class="fas fa-search"></i>
                    </b-button>
                  </template>
                </b-table>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <b-form-group
                label="Exibir"
                label-cols-lg="4"
                label-for="pageSize"
                label-size="sm"
              >
                <b-form-select
                  size="sm"
                  id="pageSize"
                  v-model="pagination.perPage"
                >
                  <b-form-select-option :value="8">8</b-form-select-option>
                  <b-form-select-option :value="20">20</b-form-select-option>
                  <b-form-select-option :value="50">50</b-form-select-option>
                  <b-form-select-option :value="0">Tudo</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="10">
              <b-pagination
                class="float-right"
                v-model="pagination.currentPage"
                :total-rows="pagination.totalRows"
                :per-page="pagination.perPage"
                aria-controls="tbl"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- MODAL -->
    <ModalTarefaPadrao
      :tarefa="curRecord"
      :action="curAction"
      @updated="onUpdated"
    />
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import ModalTarefaPadrao from "./ModalTarefaPadrao";
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import { mapState } from "vuex";
import Vue from "vue";
export default {
  name: "TarefasPadraoList",
  components: { PageTitle, ModalTarefaPadrao },
  computed: mapState["user"],
  data: function () {
    return {
      pagination: {
        perPage: 8,
        totalRows: 0,
        currentPage: 1,
      },
      search: "",
      search_type: 0,
      search_type_revision: 0,
      isBusy: false,
      curAction: "view",
      types: [],
      curRecord: {},
      fields: [
        {
          key: "tarefa_id",
          label: "Código",
          sortable: true,
          class: "w120-field",
        },
        { key: "descricao", label: "Descrição", sortable: true },
        {
          key: "ind_tipo",
          label: "Tipo",
          sortable: true,
          formatter: function (val) {
            if (val == 1) return "OBRAS";
            else if (val == 2) return "SERVIÇO NÃO CONSULTORIA";
            else return "CONSULTORIA FIRMAS";
          },
        },
        {
          key: "ind_tp_revisao",
          label: "Tipo Revisão",
          sortable: true,
          formatter: function (val) {
            if (val == 1) return "EX-ANTE";
            else if (val == 2) return "EX-POST";
            else return "NACIONAL";
          },
        },
        {
          key: "predecessora_id",
          label: "Predecessora",
          sortable: true,
          class: "w140-field",
        },
        {
          key: "controle_id",
          label: "Controle",
          sortable: true,
          class: "w140-field",
          formatter: function(val){
            let texto = "";
            switch (val) {
              case "":
                texto = "Sem Controle";
                break;
              case "CHAMAMENTO_PUBLICO":
                texto = "Licitação - Dt Chamamento Público";
                break;
              case "ENTREGA_MI":
                texto = "Licitação - Dt Entrega da MI";
                break;
              case "CBR1_DATA":
                texto = "Licitação - 1ª Não Objeção - Dt CBR";
                break;
              case "PUBLIC_LICITACAO":
                texto = "Licitação - Dt Publicação";
                break;
              case "ABERT_LICITACAO":
                texto = "Licitação - Dt Abertura";
                break;
              case "CBR2_DATA":
                texto = "Licitação - 2ª Não Objeção - Dt CBR";
                break;
              case "PROPOSTA_PRECO":
                texto = "Licitação - Dt Proposta Preços";
                break;
              case "REUNIAO_NEGOC":
                texto = "Licitação - Dt Reunião Negociação";
                break;
              case "CBR3_DATA":
                texto = "Licitação - 3ª Não Objeção - Dt CBR";
                break;
              case "ASSINATURA_CONTRATO":
                texto = "Contrato - Dt Assinatura Contrato";
                break;
              case "OS":
                texto = "Contrato - Dt OS";
                break;                
              case "DATA_INICIAL":
                texto = "Marco - Dt Inicial";
                break;                
              case "DATA_FINAL":
                texto = "Cálculo - Dt Final";
                break;                

              default:
                texto = "";
                break;
            }
            return texto;
          }
        },

        { key: "actions", label: "Ações", class: "w120-field" },
      ],
    };
  },
  methods: {
    onUpdated() {
      this.curAction = "view";
      this.curRecord = {};
      this.getData();
    },
    editRecord(item) {
      this.curAction = "edit";
      this.curRecord = { ...item };
      this.$bvModal.show("modal-tarefa-padrao");
    },
    viewRecord(item) {
      this.curAction = "view";
      this.curRecord = { ...item };
      this.$bvModal.show("modal-tarefa-padrao");
    },
    newRecord() {
      this.curAction = "new";
      this.curRecord = {
        tarefa_id: 0,
        ind_tipo: 1,
        predecessora_id: 0,
        ordem_id: 10,
      };
      Vue.nextTick().then(() => {
        this.$bvModal.show("modal-tarefa-padrao");
      });
    },
    deleteRecord(item) {
      this.$bvModal
        .msgBoxConfirm(`Excluir a Tarefa ${item.tarefa_id}?`, {
          noFade: true,
          okTitle: "Excluir",
          cancelTitle: "Cancelar",
          buttonSize: "sm",
          footerClass: "confirm-dialog",
        })
        .then((yesno) => {
          if (yesno) {
            this.isBusy = true;
            axios
              .delete(`${baseApiUrl}/bid/tarefaspadrao/${item.tarefa_id}`)
              .then(() => this.getData())
              .catch((err) => {
                this.isBusy = false;
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
    getData() {
      this.isBusy = true;
      axios
        .get(
          `${baseApiUrl}/bid/tarefaspadrao/list?ind_tipo=${this.search_type}&ind_tp_revisao=${this.search_type_revision}`
        )
        .then((resp) => {
          resp.data;
          this.isBusy = false;
          this.types = resp.data;
          this.pagination.totalRows = this.types.length;
        })
        .catch((err) => {
          this.isBusy = false;
          showError(err);
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style>
</style>